import StatusPageLayout from "../../components/StatusPageLayout";

export const PageNotFound = () => (
  <StatusPageLayout
    // code="404"
    title="Page Not Found"
    message={`The page you're looking for does not exist or has been moved.`}
  />
);
